import { getRovoParams } from '@atlaskit/rovo-triggers/params';
import type { EntryPointRef } from '@atlassian/entry-point-types/types';
import { browseAgentEntryPoint } from '@atlassian/studio-browse-kit/browse-agent-entrypoint';
import { loadEntryPoint } from 'react-relay';

import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

type BrowseAgentResourceData = EntryPointRef<typeof browseAgentEntryPoint>;

export const getBrowseAgentResourceKey = (cloudId: string): string =>
	`browse-agent-resource-${cloudId}`;

export const getBrowseAgentCloudId = (context: HomeResourceContext): string => {
	const { cloudId: cloudIdOverride } = getRovoParams();
	return cloudIdOverride ?? context.collabContext?.rovoWorkspace ?? context.cloudIds?.at(0) ?? '';
};

export const browseAgentResource: RouteResource<BrowseAgentResourceData | undefined> =
	createResource<BrowseAgentResourceData | undefined>({
		type: 'BROWSE_AGENT',
		getKey: (_routerContext, resourceContext) => {
			const context = resourceContext as HomeResourceContext;
			const cloudId = getBrowseAgentCloudId(context);

			return getBrowseAgentResourceKey(cloudId);
		},
		getData: async (_routerContext, resourceContext) => {
			const context = resourceContext as HomeResourceContext;
			const cloudId = getBrowseAgentCloudId(context);

			if (!cloudId) {
				return;
			}

			return loadEntryPoint({ getEnvironment: getAggRelayEnvironment }, browseAgentEntryPoint, {
				cloudId,
				product: 'atlassian-studio',
			});
		},
	});
